









































import Vue from "vue";
import ListTemplate from "@/components/templates/ListTemplate.vue";
import WorldViewList from "@/components/organisms/WorldViewList.vue";
import WorldViewFolderList from "@/components/organisms/WorldViewFolderList.vue";
import WorldViewDetail from "@/components/organisms/WorldViewDetail.vue";
import SpTab from "@/components/molecules/SpTab.vue";
import BackToList from "@/components/atoms/BackToList.vue";
import { callApi } from "@/lib/api";
import { Plan } from "@/lib/models";
// NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
// import { Dialog } from "@/lib/utils";
// import PremiumFeatureDialog, { PremiumFeatureDialogProps } from "@/components/ui/PremiumFeatureDialog.vue";
// import { downloadPublicImage } from "@/lib/s3";

export default Vue.extend({
  components: {
    ListTemplate,
    WorldViewList,
    WorldViewFolderList,
    WorldViewDetail,
    BackToList,
    SpTab,
  },
  props: {
    novelId: String,
    worldViewId: String,
  },
  data() {
    return {
      worldViews: null,
      selected: null,
      worldViewsCount: null,
      folders: null,
      isShowFolderList: false,
      isFolderInsertMode: false,
      targetWorldView: null,
      worldViewFolder: null,
      selectedFolderId: null,
    };
  },
  async created() {
    const worldViews = await this.getWorldViews();
    this.worldViews = worldViews.items;
    this.worldViewsCount = worldViews.items.length;
    const worldViewFolders = await this.getFolders();
    this.folders = worldViewFolders.items;
    this.load();
  },
  computed: {
    plan() {
      return this.$store.getters["userModule/plan"] as Plan;
    },
    isFree() {
      return this.plan === Plan.free;
    },
  },
  methods: {
    async getWorldViews() {
      const { novelId } = this;
      const GetQuery = `
        query Query($input: ListWorldViewInput!) {
          worldViews (input: $input) {
            nextToken
            items {
              novelId
              worldViewId
              name
              image
              createdAt
              updatedAt
              detail {
                name
                value
              }
              additionalColumn {
                name
                label
                content
              }
            }
          }
        }`;
      const { worldViews } = await callApi(GetQuery, {
        input: {
          novelId,
        },
      });
      return worldViews;
    },
    async getFolders() {
      const { novelId } = this;
      const ListWorldViewFolder = `
        query ListWorldViewFolder ($novelId: ID!){
          worldViewFolders (novelId: $novelId){
            novelId
            items {
              worldViewFolderId
              name
              worldViewKeys
            }
          }
        }`;
      const { worldViewFolders } = await callApi(ListWorldViewFolder, {
        novelId,
      });
      return worldViewFolders;
    },
    async selectFolder(worldViewFolderId) {
      const { novelId } = this;
      const query = `
        query ListFolderWorldView ($input: GetFolderWorldViewsInput!) {
          folderWorldViews (input: $input) {
            items {
              novelId
              worldViewId
              name
              image
              createdAt
              updatedAt
              detail {
                name
                value
              }
              additionalColumn {
                name
                label
                content
              }
            }
          }
        }`;
      const { folderWorldViews } = await callApi(query, {
        input: {
          novelId,
          worldViewFolderId,
        },
      });
      this.worldViews = folderWorldViews.items;
      this.worldViewFolder = this.folders.find((folder) => {
        return folder.worldViewFolderId === worldViewFolderId;
      });
      try {
        if (this.worldViewFolder) {
          this.worldViews.sort((x, y) => {
            return (
              this.worldViewFolder.worldViewKeys.indexOf(x.worldViewId) -
              this.worldViewFolder.worldViewKeys.indexOf(y.worldViewId)
            );
          });
        }
      } catch (error) {
        console.log(error);
      }
      this.isShowFolderList = false;
    },
    async showFolderList() {
      if (this.isFree) {
        this.showPremiumFeatureDialog();
        return;
      }

      const worldViews = await this.getWorldViews();
      const worldViewFolders = await this.getFolders();

      this.worldViews = worldViews.items;
      this.worldViewsCount = worldViews.items.length;
      this.folders = worldViewFolders.items;
      this.isShowFolderList = true;
    },
    setFolder(el) {
      if (this.isFree) {
        this.showPremiumFeatureDialog();
        return;
      }

      this.targetWorldView = el.worldView;
      this.selectedFolderId = el.worldViewFolder ? el.worldViewFolder.worldViewFolderId : null;
      this.isFolderInsertMode = true;
      this.isShowFolderList = true;
    },
    async finishFolderSelect() {
      await this.selectFolder(this.selectedFolderId);

      this.targetWorldView = null;
      this.isFolderInsertMode = false;
      this.isShowFolderList = false;
    },
    cancelInsertFolder() {
      this.isFolderInsertMode = false;
      this.isShowFolderList = false;
    },
    deleteHandle(worldViewId) {
      const { novelId } = this;
      const index = this.worldViews.findIndex((item) => item.worldViewId === worldViewId);
      this.$delete(this.worldViews, index);
      this.$router.push({
        name: "worldViews",
        params: { novelId },
      });
    },
    load() {
      const list = this.worldViews;
      if (!list) {
        this.selected = null;
        return;
      }
      if (this.worldViewId) {
        this.selected = list.find((c) => c.worldViewId === this.worldViewId);
        return;
      }
      if (list.length) {
        this.selected = list[0];
      }
    },
    async showPremiumFeatureDialog() {
      // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
      // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
      // const data: PremiumFeatureDialogProps = {
      //   title: "フォルダ機能はプレミアム機能です",
      //   text: "Nolaプレミアムにご登録いただくと、お好きな名前で資料を管理できる『フォルダ管理機能』をご利用いただけます。”〇〇国”や”〇〇星”などの世界ごとの管理や、キャラクターが登場するシーンごとの資料管理ができますので、お手すきの際にぜひご活用いただだけたら幸いです。",
      //   image: (await downloadPublicImage("shared/images/gif/worldview_folder.gif")) as string,
      // };
      // premiumFeatureDialog.show(data);

      this.$router.push({ name: "subscriptionAnnounce", query: { from: "worldviewFolder" } });
    },
  },
  watch: {
    $route: "load",
  },
});
